module.exports = __webpack_public_path__ + "static/media/wellness-web-2.f42175cc.jpg";